import { Input } from "components/inputs";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const InputContainer = styled.div`
  display: flex;
  margin-top: 10px;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    margin-top: 30px;

    button {
      margin-top: 10px;
    }
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  margin-right: 15px;
  box-sizing: border-box;
`;
